import { c as _c } from "react/compiler-runtime";
import { LINK_PREFIX } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import styles from './PromoBannerCard.module.scss';
const PromoBannerCard = t0 => {
  const $ = _c(12);
  const {
    promoCard
  } = t0;
  const t1 = promoCard.url;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles.root, styles.link);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== promoCard.title) {
    t3 = <SafeHtmlRenderer content={promoCard.title} className={styles.title} tag="div" />;
    $[1] = promoCard.title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className={styles.link}>Подробнее</p>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <div className={styles.content}>{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `${LINK_PREFIX}${promoCard.img}`;
  let t7;
  if ($[6] !== t6) {
    t7 = <div className={styles.icon}><Image fill={true} src={t6} alt={"\u0438\u043A\u043E\u043D\u043A\u0430 \u043F\u0440\u043E\u043C\u043E \u0430\u043A\u0446\u0438\u0438"} fetchPriority="high" priority={true} /></div>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== promoCard.url || $[9] !== t5 || $[10] !== t7) {
    t8 = <Link href={t1} className={t2}>{t5}{t7}</Link>;
    $[8] = promoCard.url;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default PromoBannerCard;